import React from 'react'
import { createBrowserRouter, RouterProvider, createRoutesFromElements, Route, ShouldRevalidateFunction } from 'react-router-dom'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { withTheme } from './loaders/withTheme'
import applePayPageLoader from './loaders/applePayPageLoader'
import paymentPageLoader from './loaders/paymentPageLoader'
import paymentResultPageLoader from './loaders/paymentResultPageLoader'
import p2pPayPageLoader from './loaders/p2pPayPageLoader'
import pixPayPageLoader from './loaders/pixPayPageLoader'
import PageLayout from './components/PageLayout/PageLayout'
import PaymentPageErrorBoundary from './components/ErrorBoundary/PaymentPageErrorBoundary'
import PaymentResultPageErrorBoundary from './components/ErrorBoundary/PaymentResultPageErrorBoundary'
import LoadingOverlay from './components/LoadingOverlay/LoadingOverlay'
import ApplePayPage from './pages/ApplePayPage/ApplePayPage'
import NotFoundPage from './pages/ErrorPage/NotFoundPage'
import PaymentResultPage from './pages/PaymentResultPage/PaymentResultPage'
import PaymentPage from './pages/PaymentPage/PaymentPage'
import P2PPage from './pages/P2PPage/P2PPage'
import PixPage from './pages/PixPage/PixPage'
import './vars.css'
import './App.css'

const shouldRevalidatePaymentPage: ShouldRevalidateFunction = ({ currentParams, nextParams }) => {
    return currentParams.paymentPageId !== nextParams.paymentPageId
}

const shouldRevalidateTrnPage: ShouldRevalidateFunction = ({ currentParams, nextParams }) => {
    return currentParams.paymentPageId !== nextParams.paymentPageId || currentParams.transactionId !== nextParams.transactionId
}

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<PageLayout />}>
            <Route path="/payment/:paymentPageId">
                <Route
                    path="apple/:transactionId"
                    element={<ApplePayPage />}
                    loader={withTheme(applePayPageLoader)}
                    shouldRevalidate={shouldRevalidateTrnPage}
                    errorElement={<PaymentPageErrorBoundary />}
                />
                <Route
                    path="pix/:transactionId"
                    element={<PixPage />}
                    loader={withTheme(pixPayPageLoader)}
                    shouldRevalidate={shouldRevalidateTrnPage}
                    errorElement={<PaymentPageErrorBoundary />}
                />
                <Route
                    path="p2p/:transactionId"
                    element={<P2PPage />}
                    loader={withTheme(p2pPayPageLoader)}
                    shouldRevalidate={shouldRevalidateTrnPage}
                    errorElement={<PaymentPageErrorBoundary />}
                />
                <Route
                    path=":method?"
                    element={<PaymentPage />}
                    loader={withTheme(paymentPageLoader)}
                    shouldRevalidate={shouldRevalidatePaymentPage}
                    errorElement={<PaymentPageErrorBoundary />}
                />
                <Route
                    path="*"
                    element={<NotFoundPage />}
                    loader={withTheme()}
                />
            </Route>

            <Route path="/result/:paymentPageId">
                <Route
                    index
                    path=":transactionId"
                    element={<PaymentResultPage />}
                    loader={withTheme(paymentResultPageLoader)}
                    shouldRevalidate={shouldRevalidateTrnPage}
                    errorElement={<PaymentResultPageErrorBoundary />}
                />
                <Route
                    path="*"
                    element={<NotFoundPage />}
                    loader={withTheme()}
                />
            </Route>

            <Route
                path="*"
                element={<NotFoundPage />}
            />
        </Route>
    ),
)

const App = () => {
    return (
        <I18nProvider i18n={i18n}>
            <RouterProvider
                router={router}
                fallbackElement={<LoadingOverlay />}
            />
        </I18nProvider>
    )
}

export default App
